import React from 'react';

import { ListBanner } from '@qality/common-components/src/molecules/ListBanner';
import { StorageOfUniqueServices } from '@qality/common-service';

import { BannerContainer } from './TestCycleTestCasesListTabBanner.styled';

const BANNER_TITLE = 'Improve Test Cycles management with QAlity Plus';
const BANNER_ITEMS = [
  'Benefit from unlimited Test Cycles visibility.',
  'Reorder Test Cases effortlessly with the drag-and-drop feature. ',
  'Sort Test Cases within Test Cycles to easily access all the information you need.',
  'Add Test Cases from any project to your Test Cycle.',
  'Move between Test Cases without visiting Test Cycle Overview every time.',
];

const PRIMARY_ACTION_TEXT = 'Try it free';
const SECONDARY_ACTION_TEXT = 'Learn more about QAlity Plus';

export function TestCycleTestCasesListTabBanner() {
  const { getQalityPlusMarketplaceUrl, getQalityVersionsComparisonUrl } =
    StorageOfUniqueServices.get('URLService');

  return (
    <BannerContainer>
      <ListBanner
        title={BANNER_TITLE}
        items={BANNER_ITEMS}
        primaryAction={{
          text: PRIMARY_ACTION_TEXT,
          link: getQalityPlusMarketplaceUrl(),
        }}
        secondaryAction={{
          text: SECONDARY_ACTION_TEXT,
          link: getQalityVersionsComparisonUrl(),
        }}
      />
    </BannerContainer>
  );
}
